import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { notificationActions } from '../actions/notification';
import { NotificationsPage } from '../components/notificationsPage';
import { getAllNotificationHistory, } from '../selectors/notifications';
const { notificationHistoryReset, notificationGetPersisted, notificationGetFailedBulkActions, } = notificationActions;
const mapStateToProps = (state) => {
    const { notifications: { notificationsHistory, persistedNotifications }, } = state;
    return {
        notificationsHistory,
        persistedNotifications,
        allNotifications: getAllNotificationHistory(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        notificationHistoryReset: () => dispatch(notificationHistoryReset()),
        notificationGetPersisted: bindActionToPromise(dispatch, notificationGetPersisted),
        notificationGetFailedBulkActions: bindActionToPromise(dispatch, notificationGetFailedBulkActions),
        dispatch,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(NotificationsPage);
